import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import LetterX from "../UI/LetterX";
import {
  deleteMedicamento,
  setearValorEnMedicamento,
} from "../../../actions/recetasDigitales/RecetasDigitales";

const InfoAdicionalMedicamento = (props) => {
  const dispatch = useDispatch();
  const disabledProp = false;

  useEffect(() => {
    dispatch(
      setearValorEnMedicamento(
        props.medicamento?.idMedicamento,
        "cantidad",
        Number(props.cantidad)
      )
    );
  }, []);

  return (
    <div style={{padding:"2em"}}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={10} style={{display:'flex'}}>
          {!disabledProp && (
            <LetterX
              deleteFunction={() => {
                dispatch(deleteMedicamento(props.medicamento?.idMedicamento));
              }}
              styles={{
                cursor: "pointer",
                position: "relative",
                top: "0.25rem",
                right: "0.2rem",
                marginRight: "0.2rem",
                marginTop: 18
              }}
            />
          )}
          <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, marginTop: 18, width: "90%" }}>
            {`${props.medicamento?.medicamento?.presentacion} | ${props.medicamento?.medicamento?.laboratorio} | ${props.medicamento?.medicamento?.nombre} | ${props.medicamento?.medicamento?.drogas}`}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <TextField
            variant="outlined"
            type="number"
            label="Cant. p/presentación"
            value={props.cantidad}
            fullWidth
            disabled={disabledProp}
            onChange={(e) => {
              props.setCantidad(e.target.value);
              dispatch(
                setearValorEnMedicamento(
                  props.medicamento?.idMedicamento,
                  "cantidad",
                  Number(e.target.value)
                )
              );
            }}
            error={props.cantidad <= 0}
            helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            //type="number"
            fullWidth
            label="Dosis"
            value={props.dosis}
            disabled={disabledProp}
            onChange={(e) => {
              props.setDosis(e.target.value);
              dispatch(
                setearValorEnMedicamento(
                  props.medicamento?.idMedicamento,
                  "dosis",
                  e.target.value
                )
              );
            }}
            /*error={props.dosis === ""}
            helperText={props.dosis === "" && "Debe ingresar dosis."}*/
          />
        </Grid>
        <Grid item xs={8}>
          <TextField
            variant="outlined"
            //type="number"
            fullWidth
            label="Posología"
            value={props.posologia}
            disabled={disabledProp}
            onChange={(e) => {
              props.setPosologia(e.target.value);
              dispatch(
                setearValorEnMedicamento(
                  props.medicamento?.idMedicamento,
                  "posologia",
                  e.target.value
                )
              );
            }}
            /*error={props.posologia === ""}
            helperText={props.posologia === "" && "Debe ingresar posología."}*/
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default InfoAdicionalMedicamento;
